import React from 'react';
import { Avatar, Grid, IconButton, LinearProgress, Tooltip, Typography } from '@material-ui/core';
import FileIcon from '@material-ui/icons/AttachFileTwoTone';
import DeleteIcon from '@material-ui/icons/DeleteTwoTone';
import CancelIcon from '@material-ui/icons/CancelTwoTone';
import RestartIcon from '@material-ui/icons/ReplayTwoTone';
import { formatBytes } from 'react-dropzone-uploader';

/* eslint react/prop-types: 0 */
const ImmediateFileUploaderCustomPreview = (
  {
    fileWithMeta: { cancel, remove, restart },
    meta: { name = '', percent = 0, size = 0, previewUrl, status },
    isUpload,
    canCancel,
    canRemove,
    canRestart,
  }
) => {
  const progress = status === 'done' || status === 'headers_received' ? 100 : percent;
  const getStatusText = (status) => {
    switch (status) {
      case 'error_validation':
        return 'Niedozwolony rodzaj pliku';
      case 'done':
      case 'headers_received':
        return 'Plik załączono';
      case 'error_file_size':
        return 'Rozmiar pliku przekracza dopuszczalny';
      case 'uploading':
        return 'Zalączanie pliku...';
      case 'error_upload_params':
      case 'exception_upload':
      case 'error_upload':
        return 'Załączanie pliku nie powiodło się';
      case 'aborted':
        return 'Anulowano';
      default:
        return status;
    }
  };

  return (
    <Grid container
      direction="row"
      alignItems="center"
      justify="flex-start"
      style={{ padding: 8 }}>
      <Grid item xs={1}>
        {previewUrl
          ? <Avatar src={previewUrl} />
          : <Avatar>
            <FileIcon />
          </Avatar>
        }
      </Grid>
      <Grid item xs={5}>
        <Typography variant="subtitle2">{name}</Typography>
        <Typography variant="caption">{formatBytes(size)}</Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={3} style={{ display: 'flex', flexDirection: 'column' }}>
        {isUpload && <LinearProgress variant="determinate" value={progress} />}
        <Typography variant="caption">{getStatusText(status)}</Typography>
      </Grid>
      <Grid item xs={1} style={{ display: 'flex', flexDirection: 'row' }}>
        {status === 'uploading' && canCancel &&
          <Tooltip title="Anuluj">
            <IconButton edge="end" aria-label="anuluj" onClick={() => cancel()}>
              <CancelIcon />
            </IconButton>
          </Tooltip>
        }
        {['error_upload_params', 'exception_upload', 'error_upload', 'aborted', 'ready'].includes(status)
          && canRestart &&
          <Tooltip title="Ponów">
            <IconButton edge="end" aria-label="ponów" onClick={() => restart()}>
              <RestartIcon />
            </IconButton>
          </Tooltip>
        }
        {status !== 'preparing' && status !== 'getting_upload_params' && status !== 'uploading' && canRemove &&
          <Tooltip title="Usuń">
            <IconButton edge="end" aria-label="usuń" onClick={() => remove()}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        }
      </Grid>
    </Grid >
  );
};

export default ImmediateFileUploaderCustomPreview;



// WEBPACK FOOTER //
// ./src/components/common/ImmediateFileUploaderCustomPreview.js